
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/forms/form15";
const form15State = namespace("Form15");

import Form15ProcessHeader from "@/components/process/Form15/components/Form15ProcessHeader.vue";
import Spinner from "@/components/utils/Spinner.vue";
import { packageInfoType } from '@/types/Information';
import { form15StatusInfoType } from '@/types/Information/Form15';

@Component({
    components:{
        Form15ProcessHeader,
        Spinner
    }
})
export default class SubmitForm15 extends Vue {

    @form15State.State
    public currentConsentOrderId: string;

    stepsCompleted = {} as form15StatusInfoType;  
    mountedData = false; 
    packageInfo = {} as packageInfoType;
    submitting = false;
    errorMsg=""

    mounted() {
        this.mountedData = false;    
        this.submitting = false;    
        this.errorMsg = ""
        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;         
    }    

    public savePdf(){        
        const pdfType = "FORM"
        const pdfName ="Form15"
        const url = '/form15/form-print/'+this.currentConsentOrderId+'/?pdf_type='+pdfType
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }
        this.$http.get(url, options)
        .then(res => {
            const blob = res.data;
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = pdfName+".pdf";
            link.click();
            setTimeout(() => URL.revokeObjectURL(link.href), 1000);          

        },err => {
            console.error(err);
        });
    }     

    public cancel() {
        this.$router.push({name: "dashboard" }) 
    }
}
